<template>
    <!-- TODO: move the web/mobile to different files -->
    <section>
        <div class="card web">
            <div class="header">
                <div class="row-wrap header-title">
                    <div class="col" v-if="!expanded">
                        <h3 class="gold-text row-wrap">
                            <h1 class="gold-text">{{ hoursPerWeekLabel }}</h1>
                            Hours/week
                        </h3>
                    </div>
                    <div v-if="expanded">
                        <p class="gold-text">Course workload</p>
                        <h4 class="gold-text">
                            <strong>{{ hoursPerWeekLabel }} Hours/week</strong>
                        </h4>
                    </div>
                    <div class="row expand-button" v-if="!expanded" v-on:click="onExpand">
                        <strong class="primary-text">View Full Report</strong>
                        <img src="@/assets/icons/actions/expand-icon.svg" />
                    </div>
                    <div class="row expand-button" v-if="expanded" v-on:click="onExpand">
                        <p class="minor-text">Close Full Report</p>
                        <img src="@/assets/icons/actions/shrink-icon.svg" />
                    </div>
                </div>
                <p class="minor-text subheader" v-if="!expanded && workloadValues.length > 0">
                    <strong>{{ workloadLabels[0] }}</strong> takes up most of the time ({{
                        percentage(workloadValues[0])
                    }}%)
                </p>
            </div>
            <div class="body" v-if="expanded && workloadValues.length > 0">
                <div class="row-wrap body-section" id="donut-section">
                    <Donut :initialValues="workloadValues" :initialLabels="workloadLabels" :colors="workloadColors" />
                    <div class="col-wrap" id="donut-text">
                        <h5 class="minor-text">Rough conversion</h5>
                        <div
                            class="row donut-text-item"
                            v-for="(hours, idx) in workloadValues"
                            :key="`donut-item-${idx}`"
                        >
                            <span class="donut-text-num" :style="donutItemNumColor(idx)"
                                ><strong>{{ idx + 1 }}</strong></span
                            >
                            <p :style="donutItemTextColor(idx)">
                                {{ workloadLabels[idx] }} - {{ Math.round(hours * 100) / 100 }} hours
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mobile">
            <div class="header">
                <h3 class="gold-text">
                    <strong>{{ hoursPerWeekLabel }} Hours/week</strong>
                </h3>
                <p class="minor-text" v-if="!expanded">
                    <strong>{{ workloadLabels[0] }}</strong> takes up most of the time ({{
                        percentage(workloadValues[0])
                    }}%)
                </p>
            </div>
            <div class="mobile-body" :style="!expanded ? 'margin-top: 24px' : 'margin-top: 0'">
                <div class="col" id="mobile-donut-section" v-if="expanded">
                    <Donut
                        :initialValues="workloadValues"
                        :initialLabels="workloadLabels"
                        :colors="workloadColors"
                        :mobile="true"
                        :expand="expanded"
                        ref="donut"
                    />
                </div>
                <div class="row" id="mobile-body-header">
                    <span class="divider" />
                    <span class="row" id="expand-mobile-button" @click="onExpandMobile">
                        <p class="minor-text" id="mobile-expand-text" v-if="!expanded">View Full Report</p>
                        <img src="@/assets/icons/actions/expand-gray-icon.svg" v-if="!expanded" />
                        <p class="minor-text" id="mobile-expand-text" v-if="expanded">Close Full Report</p>
                        <img class="closed" src="@/assets/icons/actions/shrink-gray-icon.svg" v-if="expanded" />
                    </span>
                    <span class="divider" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Donut from "@/components/other/DonutChart";

export default {
    name: "WorkloadCard",
    props: {
        hoursPerWeek: {
            type: Array,
            required: true,
        },
        hoursBreakdown: {
            type: Object,
            required: true,
        },
        additionalInfo: Object,
    },
    components: {
        Donut,
    },
    computed: {},
    methods: {
        onExpand() {
            this.$parent.$emit("expand");
            this.expanded = !this.expanded;
        },
        onExpandMobile() {
            this.expanded = !this.expanded;
        },
        donutItemNumColor(idx) {
            return {
                "background-color": this.workloadColors[idx % 5],
            };
        },
        donutItemTextColor(idx) {
            return {
                color: this.workloadColors[idx % 5],
            };
        },
        percentage(value) {
            const totalHours = this.workloadValues.reduce((x, y) => x + y);
            return Math.round((value / totalHours) * 100);
        },
        //  TODO: move to computed property
        sortInitialValues(hoursBreakdown) {
            // Filter out the labels with zero value
            Object.keys(hoursBreakdown).forEach((key) => hoursBreakdown[key] == 0 && delete hoursBreakdown[key]);

            const workloadLabels = [],
                workloadValues = [];
            const hours = Object.keys(hoursBreakdown).map((label) => [label, hoursBreakdown[label]]);
            hours.sort((a, b) => b[1] - a[1]);
            hours.forEach((elem) => {
                if (!isNaN(elem[1])) {
                    workloadLabels.push(elem[0]);
                    workloadValues.push(elem[1]);
                }
            });
            return [workloadLabels, workloadValues];
        },
    },
    data() {
        const [workloadLabels, workloadValues] = this.sortInitialValues(this.hoursBreakdown);
        return {
            hoursPerWeekLabel:
                this.hoursPerWeek.length > 1 ? this.hoursPerWeek[0] + "~" + this.hoursPerWeek[1] : this.hoursPerWeek[0],
            expanded: false,
            workloadValues: workloadValues,
            workloadLabels: workloadLabels,
            workloadColors: ["#F2A98A", "#E7DEB7", "#F0C9C3", "#A0CA6E", "#E3C855"],
        };
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/styles/_main.scss";

h1 {
    padding-right: 16px;
    font-weight: 600;
}

h3 {
    font-weight: bold;
}

h4 {
    line-height: 28px;
}

p {
    margin: 0;
}

.subheader {
    margin-top: 8px;
}

.header-title {
    margin-top: -16px;
    justify-content: space-between;
    align-items: flex-end;

    > * {
        margin-top: 16px;
    }

    h3 {
        align-items: flex-end;
    }
}

.expand-button {
    text-align: end;
    cursor: pointer;

    :first-child {
        padding-right: 8px;
        font-size: 14px;
    }
}

#donut-section {
    padding: 36px 0 0 0;
    justify-content: center;
}

svg {
    max-width: 500px;
}

#donut-text {
    margin-left: 10%;

    justify-content: center;
    max-width: 300px;

    h5 {
        width: max-content;
        font-weight: normal;
        padding: 0 0 16px 0;
    }

    & > div {
        line-height: 30px;
        padding: 9px 0 9px 0;
    }

    span {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 22px;
        height: 22px;
        border-radius: 360%;

        color: white;
        font-size: 14px;

        strong {
            margin-top: -1px;
        }
    }

    p {
        padding: 0 11px 0 11px;
    }
}

// MOBILE STYLES
.mobile {
    h3 strong {
        font-size: 20px;
    }

    p {
        font-size: 14px;
    }

    svg {
        max-width: calc(100%);
    }
}

#mobile-body-header {
    align-items: center;
}

.divider {
    height: 1px;
    width: 100%;

    background-color: #666666;
    opacity: 0.1;
}

#expand-mobile-button {
    padding: 0 16px;

    p {
        width: max-content;
        padding-right: 8px;
    }
}
</style>
